const timeAxis = () => import("@/components/common/timeAxis/Index.vue");
import * as clipWork from "./map3.js";

// ********************-----------广深--------京港澳-----------的剖切效果**********************
// import { clipPositions } from "@/components/tables/planClip/clipData.js";

import { zhuxianK } from "./zhuxianK.js";
import { laozhuxianK } from "./laozhuxianK.js";
import { laoA } from "./laoA";
import { laoB } from "./laoB";
import { laoC } from "./laoC";
import { laoD } from "./laoD";
import { xinA } from "./xinA";
import { xinB } from "./xinB";
import { xinC } from "./xinC";
import { xinD } from "./xinD";

import * as photoGraphic from "@/components/common/photoGraphic/map.js";
import { set } from "lodash";

export default {
  components: {
    timeAxis,
  },
  data() {
    return {
      clipModelId: "NewNode-edaac84f-5019-48b3-84fd-57713ef6def6",
      childId: window.sessionStorage.getItem("childId"),
      marks: {
        0: "开始",
        548: "老路 -> 新路",
        971: "结束",
      },
      flightData: {
        alt: 1730.3,
        heading: 13.7,
        lat: 22.9924257,
        lng: 113.67405754,
        pitch: -35.8,
      },
      dataGather: [],
      indexCount: 0,
      modelIdList: [
        "NewNode-2cf067f1-feff-48b4-a02b-a3386f2e5626",
        "NewNode-717ae466-57e5-420b-bda8-87a571535a7a",
      ],
      lastTimeV: 0,
      playNum: 0,
    };
  },
  methods: {
    playpause(type) {
      if (type == "play" && this.playNum <= 0) {
        this.initial();
        this.playNum += 1;
      }

      clipWork.cheshi();
    },
    watchValue(v) {
      if (
        this.dataGather[this.indexCount] &&
        v > this.dataGather[this.indexCount].list.length
      ) {
        if (this.dataGather[this.indexCount].type == "oldRoad") {
          //隐藏老路
          clipWork.colorHide(this.dataGather[this.indexCount].modelId);
        }
        this.indexCount += 1;

        // if (this.dataGather[this.indexCount].switch) {
        //   //隐藏老路
        //   this.switchFun("hide");
        // }
      }
      if (v < this.lastTimeV && this.dataGather[this.indexCount - 1]) {
        if (v <= this.dataGather[this.indexCount - 1].list.length) {
          // this.initialPosition(this.indexCount);
          // if (this.dataGather[this.indexCount].switch) {
          //   //显示老路
          //   this.switchFun("show");
          // }
          if (this.dataGather[this.indexCount].type == "oldRoad") {
            //显示老路
            clipWork.colorShow(this.dataGather[this.indexCount].modelId);
          } else {
            this.initialPosition(this.indexCount);
          }
          this.indexCount -= 1;
        }
      }
      if (
        this.dataGather[this.indexCount] &&
        this.dataGather[this.indexCount].list[v - 1]
      ) {
        clipWork.colorShow(this.dataGather[this.indexCount].modelId);
        clipWork.addPlanClipThing(
          this.dataGather[this.indexCount].modelId,
          this.dataGather[this.indexCount].list[v - 1],
          this.dataGather[this.indexCount].type
        );
        this.lastTimeV = v;
      }
    },
    initialPosition(indexCount) {
      clipWork.colorHide(this.dataGather[indexCount].modelId);
    },
    GetAngle(a, b) {
      var x = a[0] - b[0];
      var y = a[1] - b[1];
      var angle = Math.atan2(y, x);
      return angle;
    },
    GetPoint(x1, x2) {
      let aa = this.GetAngle(x1, x2);
      var x = x1[0] + 1 * Math.cos(aa + Math.PI / 2);
      var y = x1[1] + 1 * Math.sin(aa + Math.PI / 2);

      var x2 = x1[0] + 1 * Math.cos(aa - Math.PI / 2);
      var y2 = x1[1] + 1 * Math.sin(aa - Math.PI / 2);
      return [
        [x, y],
        [x2, y2],
      ];
    },
    redo() {
      // // **************坐标转经纬度  别删别删别删别删 *******************
      // let arr = clipWork.arrChange(2, xinD);
      // console.log(arr);
      // let list = [];
      // arr.forEach((el) => {
      //   if (el && el[0] && el[1]) {
      //     let str1 = el[0];
      //     let str2 = el[1];

      //     let sp1 = str1.split(",");
      //     let sp2 = str2.split(",");
      //     sp1[0] = Number(sp1[0]);
      //     sp1[1] = Number(sp1[1]);
      //     sp1[2] = Number(sp1[2]);

      //     sp2[0] = Number(sp2[0]);
      //     sp2[1] = Number(sp2[1]);
      //     sp2[2] = Number(sp2[2]);

      //     let a = this.GetPoint(sp1, sp2);
      //     list.push([
      //       clipWork.getData(a[0][0], a[0][1], 10),
      //       clipWork.getData(a[1][0], a[1][1], 10),
      //     ]);
      //   }
      // });
      // console.log(list);
      // console.log(JSON.stringify(list));
      // return;
      // list = clipWork.arrChange2(2, list);
      // console.log(list);
      // console.log(JSON.stringify(list));
      // return;
      // // **************坐标转经纬度  别删别删别删别删 *******************
      // console.log(this.$GLOBAL.map.getCameraView());
      this.initial();
      console.log("重置");
    },
    keyFrameFn(e) {
      // console.log(e);
    },
    timeInput(e) {
      // console.log(e);
    },
    dataConversion() {},
    switchFun(type) {
      if (type == "hide") {
        this.dataGather.forEach((el) => {
          if (el.type == "oldRoad") {
            clipWork.colorHide(el.modelId);
          }
        });
      } else {
        this.dataGather.forEach((el) => {
          if (el.type == "oldRoad") {
            clipWork.colorShow(el.modelId);
          }
        });
      }
    },
    initial() {
      this.indexCount = 0;
      this.lastTimeV = 0;

      this.dataGather.forEach((el) => {
        if (el.type == "newRoad") {
          clipWork.colorHide(el.modelId);
        } else {
          clipWork.colorShow(el.modelId);
        }
      });
    },
    init() {
      this.playNum = 0;
      this.dataGather = [];
      this.dataGather = [
        // 老K
        {
          list: JSON.parse(JSON.stringify(laozhuxianK)),
          modelId: "NewNode-c65a111b-e9e2-4921-8386-de122fd3767f",
          type: "oldRoad",
        },
        {
          list: JSON.parse(JSON.stringify(laoA)),
          modelId: "NewNode-717ae466-57e5-420b-bda8-87a571535a7a",
          type: "oldRoad",
        },
        {
          list: JSON.parse(JSON.stringify(laoB)),
          modelId: "NewNode-ddc74958-0b66-4a2e-9756-fb6d9daec1c1",
          type: "oldRoad",
        },
        {
          list: JSON.parse(JSON.stringify(laoC)),
          modelId: "NewNode-4792369f-1617-4cf7-bbd6-29b75128d7a4",
          type: "oldRoad",
        },
        {
          list: JSON.parse(JSON.stringify(laoD)),
          modelId: "NewNode-81eb38f3-c76a-4b6c-a156-9d8a95278b40",
          type: "oldRoad",
        },
        //新
        {
          list: JSON.parse(JSON.stringify(zhuxianK)),
          modelId: "NewNode-6a31ddb2-9c88-4dc1-b03a-b3226aecbd8f",
          type: "newRoad",
          switch: true,
        },
        {
          list: JSON.parse(JSON.stringify(xinA)),
          modelId: "NewNode-61216fdd-5ffd-4361-b2d2-807776129312",
          type: "newRoad",
        },
        {
          list: JSON.parse(JSON.stringify(xinB)),
          modelId: "NewNode-da25221c-7859-40bf-8a59-8e4c3ed3dcee",
          type: "newRoad",
        },
        {
          list: JSON.parse(JSON.stringify(xinC)),
          modelId: "NewNode-5cd9c815-3255-41e8-9978-a0faec3024b2",
          type: "newRoad",
        },
        {
          list: JSON.parse(JSON.stringify(xinD)),
          modelId: "NewNode-dfac19b2-97af-480f-a847-64f4ccc6490c",
          type: "newRoad",
        },
      ];
      let len = 0;
      this.dataGather.forEach((element) => {
        len += element.list.length;
      });
      // alert(len);
      for (let i = 0; i < this.dataGather.length; i++) {
        if (this.dataGather[i + 1]) {
          for (let i2 = 0; i2 < this.dataGather[i].list.length; i2++) {
            this.dataGather[i + 1].list.unshift("占位");
          }
        }
      }
    },
  },
  mounted() {
    photoGraphic.flight(this.flightData, null, (e) => {});
    clipWork.Initialization();
  },
  destroyed() {},
  watch: {},
};
